import { Component, Inject, Signal } from '@angular/core';
import {
  ContributionsTableComponent,
  DIALOG_DATA,
  DIALOG_REF,
  DialogService,
  SnackBarService,
} from '@ansys-internal/awf-angular/shared';
import { DashboardTables } from '@ansys-internal/awf-angular/dashboard';
import { lastValueFrom } from 'rxjs';
import { Size } from '@ansys-internal/awc-angular/core';
import { LibraryTransferService } from '../../../shared/services/library-transfer';
import {
  ButtonComponent,
  ButtonSize,
  ButtonType,
} from '@ansys-internal/awc-angular/buttons';
import {
  IconComponent,
  Icons,
  IconType,
} from '@ansys-internal/awc-angular/icons';
import { LibraryService as LibraryAPIService } from '../../../../api/services/LibraryService';
import { ActiveConceptState } from '../../../state/lib/active-concept.state';
import { State } from '@ansys-internal/awf-angular/store';
import { SelectItemToCreateDialogComponent } from '../select-item-to-create-dialog/select-item-to-create-dialog.component';
import { LibraryPanelComponent } from '../../widgets/library-panel/library-panel.component';
import { LayoutService } from '../../../shared/services/layout.service';
import { DialogRef } from '@angular/cdk/dialog';

@Component({
    selector: 'app-import-library-asset',
    templateUrl: './import-library-asset.component.html',
    styleUrl: './import-library-asset.component.scss',
    imports: [
        IconComponent,
        ButtonComponent,
        LibraryPanelComponent,
        ContributionsTableComponent,
    ]
})
export class ImportLibraryAssetComponent {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  readonly Icons = Icons;
  protected readonly dashboardTables = DashboardTables;
  protected readonly size = Size;
  protected total: number = 0;
  protected loading: boolean = false;
  protected selectedResource: string = '';
  protected buttonSize: ButtonSize = ButtonSize.SMALL;
  protected btnTypeSecondary: ButtonType = ButtonType.SECONDARY;
  protected libraryItemLoaded: boolean = false;
  protected addIcon: IconType = { icon: Icons.ADD };
  protected maxHeight!: Signal<number>;

  constructor(
    @Inject(DIALOG_DATA) protected data: any,
    @Inject(DIALOG_REF) private dialogRef: DialogRef,
    private transferService: LibraryTransferService,
    private snackbar: SnackBarService,
    private libraryAPIService: LibraryAPIService,
    private state: State,
    private dialogService: DialogService,
    private layoutService: LayoutService
  ) {
    this.maxHeight = this.layoutService.cardHeight;
  }

  protected setLibraryItemLoaded(): void {
    this.libraryItemLoaded = true;
  }

  protected async importResource(id: string): Promise<void> {
    if (this.loading) {
      return;
    }

    this.loading = true;

    const concept = this.state.value(ActiveConceptState);
    if (concept) {
      const resource2 = await lastValueFrom(
        this.libraryAPIService.getFromLibraryLibraryObjectIdGet(
          id,
          concept.design_instance_id as string
        )
      );

      await this.transferService.importResourceFromData(resource2);
    }

    this.snackbar.success('Resource imported successfully');
    this.dialogRef.close();
  }

  protected toggleSelection(id: string): void {
    this.selectedResource = !this.selectedResource ? id : '';
  }

  protected back(): void {
    this.libraryItemLoaded = false;
    this.selectedResource = '';
  }

  protected exportDirectToLibrary(): void {
    this.dialogService.open(SelectItemToCreateDialogComponent, {
      title: 'Select Config/Component',
      data: {},
    });

    this.dialogRef.close();
  }
}
